import React from 'react'
import styles from './BillingAddressStripeForm.module.scss'
import { AddressElement } from "@stripe/react-stripe-js"
import AppSelect from 'elements/appSelect'
import { TAX_ID_TYPES } from './domain'

const BillingAddressStripeForm = ({
  billingAddress,
  setBillingAddress,
  userFullName,
  showAddressInput,
  showTaxIdInput,
  taxIDIsRequired
}: {
  billingAddress: any
  setBillingAddress: Function
  userFullName: any
  showAddressInput: boolean
  showTaxIdInput: boolean
  taxIDIsRequired: boolean
}) => {
  const hideDropdownRef = React.useRef<any>(null)
  // const country = billingAddress.billing_details && billingAddress.billing_details.address && billingAddress.billing_details.address.country ? billingAddress.billing_details.address.country : ''
  const businessName = billingAddress && billingAddress.metadata ? billingAddress.metadata.business_name : ''
  const taxIdValue = billingAddress && billingAddress.metadata ? billingAddress.metadata.tax_id_value : ''
  // const taxIdType = billingAddress.metadata && billingAddress.metadata.tax_id_type ? billingAddress.metadata.tax_id_type.replace(/_/g, ' ').toUpperCase() : ""

  const [searchString, setSearchString] = React.useState<any>('')
  const [showtaxIDInputOnClick, setShowTaxIdInputOnClick] = React.useState<boolean>(false)

  // React.useEffect(() => {
  //   if (!country) return
  //   const data = TAX_ID_TYPES.filter((el) => el.abbr === country.toUpperCase())
  //   if (!data.length) return
  //   setSearchString(data[0].value)
  // }, [country])

  function handleBillingAddressChange(data: any) {
    const complete: boolean = data.complete
    setBillingAddress((prev: any) => ({
      ...prev,
      billing_details: {
        ...prev.billing_details,
        ...data.value
      },
      complete,
    }))
  }

  const filteredData = () => {
    // Step A: filter flat list
    const filteredFlat = (searchString && searchString.trim() !== "")
      ? TAX_ID_TYPES.filter((el) =>
        el.label.toLowerCase().includes(searchString.toLowerCase()) ||
        el.value.toLowerCase().includes(searchString.toLowerCase())
      )
      : TAX_ID_TYPES;

    // Step B: regroup by country
    return filteredFlat.reduce((acc: any, curr) => {
      if (!acc[curr.label]) {
        acc[curr.label] = [];
      }

      const formattedValue = curr.value.replace(/_/g, ' ').toUpperCase();

      acc[curr.label].push({
        ...curr,
        displayValue: formattedValue,
      });
      return acc;
    }, {});
  };

  return (
    <div className={styles.BillingAddressStripeForm__wrapper}>
      {
        showAddressInput &&
        <>
          <div className={styles.BillingAddressStripeForm__header}>
            <h3 className={styles.BillingAddressStripeForm__title}>
              Billing address <span className={styles.BillingAddressStripeForm__required}>*</span>
            </h3>
          </div>

          <AddressElement
            options={{
              mode: 'billing',
              fields: { phone: 'never' },
              defaultValues: {
                name: userFullName,
              }
            }}
            onChange={(event: any) => {
              handleBillingAddressChange(event)
            }}
          />

        </>
      }

      {
        showTaxIdInput && !taxIDIsRequired &&
         <div 
         className={styles.BillingAddressStripeForm__wrapper}
           onClick={() => setShowTaxIdInputOnClick(!showtaxIDInputOnClick)}
         >
          <h3 className={styles.BillingAddressStripeForm__taxNumber}>
            Do you have a tax number?
          </h3>
        </div>
      }

      {
        (taxIDIsRequired || showtaxIDInputOnClick) &&
        <div className={styles.BillingAddressStripeForm__wrapper}>
          <div className={styles.BillingAddressStripeForm__header}>
            <h3 className={styles.BillingAddressStripeForm__title}>
              Tax Information
              {
                taxIDIsRequired &&
                <span className={styles.BillingAddressStripeForm__required}>*</span>
              }
            </h3>
          </div>

          <div className={styles.BillingAddressStripeForm__form}>
            <input
              id="businessName"
              name="business_name"
              type="text"
              value={businessName}
              placeholder="Business name"
              onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                const { value } = e.target;
                setBillingAddress((prev: any) => ({
                  ...prev,
                  metadata: {
                    ...(prev.metadata || {}),
                    business_name: value
                  }
                }))
              }}
              onKeyDown={(e) => {
                // Prevent a leading space from being entered
                if (e.key === " " && (e.currentTarget.selectionStart === 0)) {
                  e.preventDefault();
                }
              }}
            />

            <AppSelect
              popupStyles={{ minHeight: '100px' }}
              inputClassName={styles.BillingAddressStripeForm__inputActionTrigger}
              placeholder="Tax ID type"
              hideDropdownRef={hideDropdownRef}
              value={searchString.replace(/_/g, ' ').toUpperCase()}
              markRequired
              cursorPointer
              inputIconClassName={styles.BillingAddressStripeForm__inputIconNameAction}
              onChangeValue={(e: any) => setSearchString(e.target.value)}
              onRemoveSelectedValue={() => {
                setSearchString('')
                setBillingAddress((prev: any) => ({
                  ...prev,
                  metadata: {
                    ...prev.metadata,
                    tax_id_type: null,
                  }
                }))
              }}
            >
              <div className={styles.BillingAddressStripeForm__actionTypesDropdown}>
                <TAXIDDataSelector
                  filteredData={filteredData()}
                  onDataSelected={(value: any, data: any) => {
                    setSearchString(value)
                    hideDropdownRef.current()
                    setBillingAddress((prev: any) => ({
                      ...prev,
                      metadata: {
                        ...(prev.metadata || {}),
                        tax_id_type: value,
                      }
                    }))
                  }}
                  elementContainerClass={styles.BillingAddressStripeForm__eventResourceTypelabelStyle__Dropdown}
                />
              </div>
            </AppSelect>

            <input
              type="text"
              name='tax_id_value'
              className={styles.BillingAddressStripeForm__inputSecondary}
              placeholder="VAT number"
              value={taxIdValue}
              onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                const { value } = e.target;
                setBillingAddress((prev: any) => ({
                  ...prev,
                  metadata: {
                    ...(prev.metadata || {}),
                    tax_id_value: value
                  }
                }))
              }}
              required
              onKeyDown={(e) => {
                // Prevent a leading space from being entered
                if (e.key === " " && (e.currentTarget.selectionStart === 0)) {
                  e.preventDefault();
                }
              }}
            />
          </div>
        </div>
      }

    </div>
  )
}

const TAXIDDataSelector = (
  {
    filteredData,
    onDataSelected,
    elementContainerClass,
  }: {
    filteredData: any,
    onDataSelected: any,
    elementContainerClass?: any,
  }
) => {
  const groupedData = filteredData;

  return (
    <div className={styles.TAXIDDataSelector__container}>
      {Object.keys(groupedData).length > 0 ? (
        Object.keys(groupedData).map((country) => (
          <div key={country}>
            {/* Country heading */}
            <p className={styles.TAXIDDataSelector__countryHeading}>{country}</p>

            {/* Country’s tax IDs */}
            {groupedData[country].map((dataElement: any, index: number) => (
              <div
                key={index}
                className={`${styles.TAXIDDataSelector__element__container} ${elementContainerClass ? ` ${elementContainerClass}` : ''}`}
                onClick={() => onDataSelected(dataElement.value, dataElement)}
              >
                <p className={styles.TAXIDDataSelector__element__label}>
                  {dataElement.displayValue}
                </p>
              </div>
            ))}
          </div>
        ))
      ) : (
        <h1 className={styles.TAXIDDataSelector__noResults}>
          No results found
        </h1>
      )}
    </div>
  )
}


export default BillingAddressStripeForm